import React from 'react';
import { Tabs } from '@mantine/core';
import classes from "styles/NotFound/NotFoundTab.module.css";

const HealthInsurance = [
  {
    title: 'Health Insurance',
    icon: "/aem-to-react/not-found/Health-Insurance-Icon.svg",
    description: 'Customised Comprehensive Health Plans for Your Needs',
    link: 'https://www.nivabupa.com/health-insurance.html',
  },
  {
    title: 'Health Insurance Plans',
    icon: "/aem-to-react/not-found/Health-Insurance-Plans.svg",
    description: 'All-in-One Health Coverage, Shaped for Your Requirements',
    link: 'https://www.nivabupa.com/health-insurance-plans.html',
  },
  {
    title: 'Family Health Insurance Plans',
    icon: "/aem-to-react/not-found/Family-Health-Insurance-Plans.svg",
    description: 'Health Plans as Unique as Your Family’s Needs',
    link: 'https://www.nivabupa.com/family-health-insurance-plans.html',
  },
  {
    title: 'Individual Health Insurance ',
    icon: "/aem-to-react/not-found/Individual-Health-Insurance.svg",
    description: 'Health Coverage Tailored Just for You',
    link: 'https://www.nivabupa.com/individual-health-insurance-plans.html',
  },
  {
    title: 'Critical Illness Insurance',
    icon: "/aem-to-react/not-found/Critical-Illness-Insurance.svg",
    description: 'Your Shield Against Critical Illnesses, Designed for You',
    link: 'https://www.nivabupa.com/critical-illness-insurance.html',
  },
  {
    title: 'Personal Accident Insurance',
    icon: "/aem-to-react/not-found/Personal-Accident-Insurance.svg",
    description: 'All-Round Accident Care, Designed for Your Needs',
    link: 'https://www.nivabupa.com/personal-accident-insurance.html',
  },
  {
    title: 'Senior Citizens Health Insurance',
    icon: "/aem-to-react/not-found/Senior-Citizens-Health-Insurance.svg",
    description: 'Tailored Health Coverage for Your Golden Years',
    link: 'https://www.nivabupa.com/family-health-insurance-plans/senior-citizen-family-floater.html',
  },
  {
    title: 'Maternity Health Insurance',
    icon: "/aem-to-react/not-found/Maternity-Health-Insurance.svg",
    description: 'Safety Net that Celebrates Your Journey to Parenthood',
    link: 'https://www.nivabupa.com/maternity-health-insurance.html',
  },
  {
    title: 'Mediclaim Policy',
    icon: "/aem-to-react/not-found/Mediclaim-Policy.svg",
    description: 'Personalised Mediclaim Support for Your Well-Being',
    link: 'https://www.nivabupa.com/mediclaim.html',
  },
  {
    title: 'Top up health insurance ',
    icon: "/aem-to-react/not-found/Top-up-health-insurance.svg",
    description: 'Extensive Top-Up Solution for Your Health Needs',
    link: 'https://www.nivabupa.com/top-up-health-insurance-policy.html',
  },
];
const TravelInsurance = [
  {
    title: 'Travel Insurance ',
    icon: "/aem-to-react/not-found/Travel-Insurance.svg",
    description: 'Tailored Travel Protection for Your Next Adventure',
    link: 'https://www.nivabupa.com/travel-insurance.html',
  },
  {
    title: 'International Travel Insurance',
    icon: "/aem-to-react/not-found/International-Travel-Insurance.svg",
    description: 'Your International Travel Plan, Crafted for Peace of Mind',
    link: 'https://www.nivabupa.com/travel-insurance/international-travel-insurance.html',
  },
  {
    title: 'Student Travel Insurance',
    icon: "/aem-to-react/not-found/Student-Travel-Insurance.svg",
    description: 'Study Abroad with Confidence – Insurance Made for You',
    link: 'https://www.nivabupa.com/travel-insurance/student-travel-insurance.html',
  },
  {
    title: 'Travel Insurance for US',
    icon: "/aem-to-react/not-found/Travel-Insurance-for-US.svg",
    description: 'Explore US Worry-free with Travel Insurance',
    link: ' https://www.nivabupa.com/travel-insurance/travel-insurance-usa.html',
  },
  {
    title: 'Travel Insurance for Thailand',
    icon: "/aem-to-react/not-found/Travel-Insurance-for-Thailand.svg",
    description: 'Opt for Insurance Suiting Your Thailand Journey',
    link: 'https://www.nivabupa.com/travel-insurance/travel-insurance-thailand.html',
  },
  {
    title: 'Travel Insurance for Canada',
    icon: "/aem-to-react/not-found/Travel-Insurance-for-Canada.svg",
    description: 'Traveling to Canada? Stay Protected with Insurance',
    link: ' https://www.nivabupa.com/travel-insurance/travel-insurance-canada.html',
  },
  {
    title: 'Travel Insurance for Schengen',
    icon: "/aem-to-react/not-found/Travel-Insurance-for-Schengen.svg",
    description: 'Ensure Safety with Schengen Travel Insurance Plan',
    link: 'https://www.nivabupa.com/travel-insurance/schengen-travel-insurance.html',
  },
  {
    title: 'Travel Insurance for UK',
    icon: "/aem-to-react/not-found/Travel-Insurance-for-UK.svg",
    description: 'Select Coverage for Your UK Travel Plans',
    link: 'https://www.nivabupa.com/travel-insurance/travel-insurance-uk.html',
  },
  {
    title: 'Travel Insurance for Dubai',
    icon: "/aem-to-react/not-found/Travel-Insurance-for-Dubai.svg",
    description: "Pick Insurance Matching your Dubai Travel Needs",
    link: 'https://www.nivabupa.com/travel-insurance/travel-insurance-dubai.html',
  },
];
const CorporateInsurance = [
  {
    title: 'Corporate Insurance',
    icon: "/aem-to-react/not-found/Corporate-Insurance.svg",
    description: 'Secure Your Business with Comprehensive Corporate Insurance',
    link: 'https://www.nivabupa.com/corporate-group-health-insurance.html',
  },
  {
    title: 'Start up Health Insurance',
    icon: "/aem-to-react/not-found/Start-up-Health-Insurance.svg",
    description: 'Protect Your Team with Start-up Health Insurance',
    link: 'https://www.nivabupa.com/corporate-group-health-insurance/startup-health-insurance.html',
  },
  {
    title: 'Group Personal Accident Insurance',
    icon: "/aem-to-react/not-found/Group-Personal-Accident-Insurance.svg",
    description: 'Safeguard Your Employees with Accident Insurance Coverage',
    link: 'https://www.nivabupa.com/corporate-group-health-insurance/group-personal-accident-insurance.html',
  },
  {
    title: 'Group OPD Coverage ',
    icon: "/aem-to-react/not-found/Group-OPD-Coverage.svg",
    description: 'Group OPD Benefits with Extensive Coverage',
    link: ' https://www.nivabupa.com/corporate-group-health-insurance/opd-coverage-in-health-insurance.html',
  },
  {
    title: 'Group health Insurance Claim Process',
    icon: "/aem-to-react/not-found/Group-health-Insurance-Claim-Process.svg",
    description: 'Streamline Claims with Group Health Insurance Plans',
    link: 'https://www.nivabupa.com/corporate-insurance-articles/what-is-the-claim-process-in-a-group-health-insurance-policy.html',
  },
];
const ClaimsInsurance = [
  {
    title: 'Claims',
    icon: "/aem-to-react/not-found/Claims.svg",
    description: 'Planning a Claim? Insurance Keeps it Simple',
    link: 'https://transactions.nivabupa.com/claims/pages/health-claim.aspx',
  },
];
const RenewalsInsurance = [
  {
    title: 'Renewals',
    icon: "/aem-to-react/not-found/Renewals.svg",
    description: 'Hassle-free Renewals with Your Insurance Plan',
    link: 'https://transactions.nivabupa.com/renewal/renewpolicies.aspx',
  },
];


function NotFoundTab() {
  return (
    <div className="relative w-full px-">
      <Tabs defaultValue="Health Insurance" color="#FBB444" className='w-full' classNames={classes}>
        <Tabs.List>
          <Tabs.Tab value="Health Insurance" >
            Health Insurance
          </Tabs.Tab>
          <Tabs.Tab value="Travel Insurance">
            Travel Insurance
          </Tabs.Tab>
          <Tabs.Tab value="Corporate Insurance">
            Corporate Insurance
          </Tabs.Tab>
          <Tabs.Tab value="Claims">
            Claims
          </Tabs.Tab>
          <Tabs.Tab value="Renewals">
            Renewals
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="Health Insurance">
          {/*  */}
          <div className="bg-[#00b0f6] flex flex-row justify-center w-full mt-5 rounded-xl md:px-8 px-0 pt-4 py-0">
            <div className="w-full md:h-[220px] h-[340px] relative flex md:flex-row flex-col items-center">
              <div className="md:w-[22%] w-full text-left flex flex-col gap-2.5 md:px-0 px-4">
                <div className="relative  text-white whitespace-nowrap text-sm">
                  Discover, Compare, and Save
                </div>
                <div className="text-white md:text-[1.5rem] text-xl font-semibold">
                  Your Perfect Plan Awaits&nbsp;&nbsp;you
                </div>
                <img
                  className="relative md:w-7 md:h-5 w-10 md:block hidden"
                  alt="Arrow right line"
                  loading="lazy"
                  src="/aem-to-react/not-found/arrow-right-line.svg"
                />
              </div>
              <div className="md:w-[65%] w-full">
                <img
                  className="md:w-[40%] w-full h-[230px] absolute bottom-0"
                  alt="Image"
                  loading="lazy"
                  src="/aem-to-react/not-found/404-center.png"
                />
              </div>
              <div className="md:w-[15%] w-full md:pt-0 md:ml-0 pt-6 ml-8">
                <a href='https://www.nivabupa.com/health-insurance-plans/get-quote.html' className="px-8 py-3 text-white bg-[#fbb444] rounded-[5px]">
                  Get Quote
                </a>
              </div>
            </div>
          </div>
          {/* Grid Health Insurance */}
          <div className="bg-white mt-10 w-full">
            <div className="flex md:flex-row flex-col flex-wrap gap-5 w-full">
              {HealthInsurance.map((item, index) => (
                <div key={index} className="border-nivabupa-ethinosHomeOrange md:w-[32%] w-full border rounded-md px-4 py-3 flex flex-row gap-3">
                  <a href={item.link} className="flex flex-row w-full">
                    <div className="w-[20%]">
                      <img
                        className="relative"
                        alt={item.title}
                        loading="lazy"
                        src={item.icon}
                      />
                    </div>
                    <div className="w-[80%]">
                      <p className="text-[#218AE5] max-h-[50px] font-semibold md:text-xl text-[18px] pr-6">{item.title}</p>
                      <div className="flex flex-row justify-between text-nivabupa-ethinosHomeOrange mt-3">
                        <p className="md:w-[80%] w-full">{item.description}</p>
                        <div className="flex items-center">
                          <img
                            className="relative w-6 h-6"
                            alt="Arrow right line"
                            loading="lazy"
                            src="/aem-to-react/not-found/orrange-arrow.png"
                          />
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Tabs.Panel>

        <Tabs.Panel value="Travel Insurance">
          <div className="bg-[#00b0f6] flex flex-row justify-center w-full mt-5 rounded-xl md:px-8 px-0 pt-4 py-0">
            <div className="w-full md:h-[220px] h-[340px] relative flex md:flex-row flex-col items-center">
              <div className="md:w-[22%] w-full text-left flex flex-col gap-2.5 md:px-0 px-4">
                <div className="relative  text-white whitespace-nowrap text-sm">
                  Discover, Compare, and Save
                </div>
                <div className="text-white md:text-[1.5rem] text-xl font-semibold">
                  Your Perfect Plan Awaits&nbsp;&nbsp;you
                </div>
                <img
                  className="relative md:w-7 md:h-5 w-10 md:block hidden"
                  alt="Arrow right line"
                  loading="lazy"
                  src="/aem-to-react/not-found/arrow-right-line.svg"
                />
              </div>
              <div className="md:w-[65%] w-full">
                <img
                  className="md:w-[40%] w-full h-[230px] absolute bottom-0"
                  alt="Image"
                  loading="lazy"
                  src="/aem-to-react/not-found/404-center.png"
                />
              </div>
              <div className="md:w-[15%] w-full md:pt-0 md:ml-0 pt-6 ml-8">
                <a href='https://www.nivabupa.com/health-insurance-plans/get-quote.html' className="px-8 py-3 text-white bg-[#fbb444] rounded-[5px]">
                  Get Quote
                </a>
              </div>
            </div>
          </div>
          {/* Grid Travel Insurance */}
          <div className="bg-white mt-10 w-full">
            <div className="flex md:flex-row flex-col flex-wrap gap-5 w-full">
              {TravelInsurance.map((item, index) => (
                <div key={index} className="border-nivabupa-ethinosHomeOrange md:w-[32%] w-full border rounded-md px-4 py-3 flex flex-row gap-3">
                  <a href={item.link} className="flex flex-row w-full">
                    <div className="w-[20%]">
                      <img
                        className="relative"
                        alt={item.title}
                        loading="lazy"
                        src={item.icon}
                      />
                    </div>
                    <div className="w-[80%]">
                      <p className="text-[#218AE5] max-h-[50px] font-semibold md:text-xl text-[18px] pr-6">{item.title}</p>
                      <div className="flex flex-row justify-between text-nivabupa-ethinosHomeOrange mt-3">
                        <p className="md:w-[80%] w-full">{item.description}</p>
                        <div className="flex items-center">
                          <img
                            className="relative w-6 h-6"
                            alt="Arrow right line"
                            loading="lazy"
                            src="/aem-to-react/not-found/orrange-arrow.png"
                          />
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Tabs.Panel>

        <Tabs.Panel value="Corporate Insurance">
          <div className="bg-[#00b0f6] flex flex-row justify-center w-full mt-5 rounded-xl md:px-8 px-0 pt-4 py-0">
            <div className="w-full md:h-[220px] h-[340px] relative flex md:flex-row flex-col items-center">
              <div className="md:w-[22%] w-full text-left flex flex-col gap-2.5 md:px-0 px-4">
                <div className="relative  text-white whitespace-nowrap text-sm">
                  Discover, Compare, and Save
                </div>
                <div className="text-white md:text-[1.5rem] text-xl font-semibold">
                  Your Perfect Plan Awaits&nbsp;&nbsp;you
                </div>
                <img
                  className="relative md:w-7 md:h-5 w-10 md:block hidden"
                  alt="Arrow right line"
                  loading="lazy"
                  src="/aem-to-react/not-found/arrow-right-line.svg"
                />
              </div>
              <div className="md:w-[65%] w-full">
                <img
                  className="md:w-[40%] w-full h-[230px] absolute bottom-0"
                  alt="Image"
                  loading="lazy"
                  src="/aem-to-react/not-found/404-center.png"
                />
              </div>
              <div className="md:w-[15%] w-full md:pt-0 md:ml-0 pt-6 ml-8">
                <a href='https://www.nivabupa.com/health-insurance-plans/get-quote.html' className="px-8 py-3 text-white bg-[#fbb444] rounded-[5px]">
                  Get Quote
                </a>
              </div>
            </div>
          </div>
          {/* Grid Corporate Insurance */}
          <div className="bg-white mt-10 w-full">
            <div className="flex md:flex-row flex-col flex-wrap gap-5 w-full">
              {CorporateInsurance.map((item, index) => (
                <div key={index} className="border-nivabupa-ethinosHomeOrange md:w-[32%] w-full border rounded-md px-4 py-3 flex flex-row gap-3">
                  <a href={item.link} className="flex flex-row w-full">
                    <div className="w-[20%]">
                      <img
                        className="relative"
                        alt={item.title}
                        loading="lazy"
                        src={item.icon}
                      />
                    </div>
                    <div className="w-[80%]">
                      <p className="text-[#218AE5] max-h-[50px] font-semibold md:text-xl text-[18px] pr-6">{item.title}</p>
                      <div className="flex flex-row justify-between text-nivabupa-ethinosHomeOrange mt-3">
                        <p className="md:w-[80%] w-full">{item.description}</p>
                        <div className="flex items-center">
                          <img
                            className="relative w-6 h-6"
                            alt="Arrow right line"
                            loading="lazy"
                            src="/aem-to-react/not-found/orrange-arrow.png"
                          />
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Tabs.Panel>

        <Tabs.Panel value="Claims">
          <div className="bg-[#00b0f6] flex flex-row justify-center w-full mt-5 rounded-xl md:px-8 px-0 pt-4 py-0">
            <div className="w-full md:h-[220px] h-[340px] relative flex md:flex-row flex-col items-center">
              <div className="md:w-[22%] w-full text-left flex flex-col gap-2.5 md:px-0 px-4">
                <div className="relative  text-white whitespace-nowrap text-sm">
                  Discover, Compare, and Save
                </div>
                <div className="text-white md:text-[1.5rem] text-xl font-semibold">
                  Your Perfect Plan Awaits&nbsp;&nbsp;you
                </div>
                <img
                  className="relative md:w-7 md:h-5 w-10 md:block hidden"
                  alt="Arrow right line"
                  loading="lazy"
                  src="/aem-to-react/not-found/arrow-right-line.svg"
                />
              </div>
              <div className="md:w-[65%] w-full">
                <img
                  className="md:w-[40%] w-full h-[230px] absolute bottom-0"
                  alt="Image"
                  loading="lazy"
                  src="/aem-to-react/not-found/404-center.png"
                />
              </div>
              <div className="md:w-[15%] w-full md:pt-0 md:ml-0 pt-6 ml-8">
                <a href='https://www.nivabupa.com/health-insurance-plans/get-quote.html' className="px-8 py-3 text-white bg-[#fbb444] rounded-[5px]">
                  Get Quote
                </a>
              </div>
            </div>
          </div>
          {/* Grid Claims */}
          <div className="bg-white mt-7 w-full">
            <div className="flex md:flex-row flex-col flex-wrap gap-5 w-full">
              {ClaimsInsurance.map((item, index) => (
               <div key={index} className="border-nivabupa-ethinosHomeOrange md:w-[32%] w-full border rounded-md px-4 py-3 flex flex-row gap-3">
                  <a href={item.link} className="flex flex-row w-full">
                    <div className="w-[20%]">
                      <img
                        className="relative"
                        alt={item.title}
                        loading="lazy"
                        src={item.icon}
                      />
                    </div>
                    <div className="w-[80%]">
                      <p className="text-[#218AE5] max-h-[50px] font-semibold md:text-xl text-[18px] pr-6">{item.title}</p>
                      <div className="flex flex-row justify-between text-nivabupa-ethinosHomeOrange mt-3">
                        <p className="md:w-[80%] w-full">{item.description}</p>
                        <div className="flex items-center">
                          <img
                            className="relative w-6 h-6"
                            alt="Arrow right line"
                            loading="lazy"
                            src="/aem-to-react/not-found/orrange-arrow.png"
                          />
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Tabs.Panel>

        <Tabs.Panel value="Renewals">
          <div className="bg-[#00b0f6] flex flex-row justify-center w-full mt-5 rounded-xl md:px-8 px-0 pt-4 py-0">
            <div className="w-full md:h-[220px] h-[340px] relative flex md:flex-row flex-col items-center">
              <div className="md:w-[22%] w-full text-left flex flex-col gap-2.5 md:px-0 px-4">
                <div className="relative  text-white whitespace-nowrap text-sm">
                  Discover, Compare, and Save
                </div>
                <div className="text-white md:text-[1.5rem] text-xl font-semibold">
                  Your Perfect Plan Awaits&nbsp;&nbsp;you
                </div>
                <img
                  className="relative md:w-7 md:h-5 w-10 md:block hidden"
                  alt="Arrow right line"
                  loading="lazy"
                  src="/aem-to-react/not-found/arrow-right-line.svg"
                />
              </div>
              <div className="md:w-[65%] w-full">
                <img
                  className="md:w-[40%] w-full h-[230px] absolute bottom-0"
                  alt="Image"
                  loading="lazy"
                  src="/aem-to-react/not-found/404-center.png"
                />
              </div>
              <div className="md:w-[15%] w-full md:pt-0 md:ml-0 pt-6 ml-8">
                <a href='https://www.nivabupa.com/health-insurance-plans/get-quote.html' className="px-8 py-3 text-white bg-[#fbb444] rounded-[5px]">
                  Get Quote
                </a>
              </div>
            </div>
          </div>
          {/* Grid Renewals */}
          <div className="bg-white mt-7 w-full">
            <div className="flex md:flex-row flex-col flex-wrap gap-5 w-full">
              {RenewalsInsurance.map((item, index) => (
                <div key={index} className="border-nivabupa-ethinosHomeOrange md:w-[32%] w-full border rounded-md px-4 py-3 flex flex-row gap-3">
                  <a href={item.link} className="flex flex-row w-full">
                    <div className="w-[20%]">
                      <img
                        className="relative"
                        alt={item.title}
                        loading="lazy"
                        src={item.icon}
                      />
                    </div>
                    <div className="w-[80%]">
                      <p className="text-[#218AE5] max-h-[50px] font-semibold md:text-xl text-[18px] pr-6">{item.title}</p>
                      <div className="flex flex-row justify-between text-nivabupa-ethinosHomeOrange mt-3">
                        <p className="md:w-[80%] w-full">{item.description}</p>
                        <div className="flex items-center">
                          <img
                            className="relative w-6 h-6"
                            alt="Arrow right line"
                            loading="lazy"
                            src="/aem-to-react/not-found/orrange-arrow.png"
                          />
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </Tabs.Panel>

      </Tabs>
    </div>
  );
}

export default NotFoundTab;